export default {"src":"/_next/static/media/chevDown.3f17b5ac.svg","height":6,"width":8,"blurWidth":0,"blurHeight":0};